import { Metadata } from 'next'

const metadata: Metadata = {
  title: 'Ship&Play',
  description:
    'Pack everything, carry nothing. We offer white-glove, door-to-door shipping for your ' +
    'luggage, golf clubs, skis, and gear worldwide. Get a FREE quote today!',
  icons: {
    icon: [
      { url: '/shipplay_favicon.svg', type: 'image/svg+xml' },
      { url: '/shipplay_favicon.ico', type: 'image/x-icon' },
    ],
    apple: '/shipplay_favicon.png',
  },
  alternates: {
    canonical: 'https://www.shipplay.com',
  },
}

export default metadata
